export default __webpack_public_path__ + "static/media/sala pietra.c26ffc78.jpg";